/* src/app/pages/ui-kit/components/stepper-view/stepper-demo-modal/stepper-demo-modal.component.scss */
.stepper-wrapper {
  padding: 0 16px 8px;
}
:host ::ng-deep .stepper-wrapper .p-step-title {
  font-size: 16px;
  line-height: 24px;
}
:host ::ng-deep .stepper-wrapper .p-step-number {
  line-height: 24px;
}
:host ::ng-deep .stepper-wrapper .p-step:has(~ .p-step-active) .p-step-number {
  background: var(--primary-subtle-hover);
  border-color: var(--primary-subtle-hover);
  color: var(--primary-subtle-inverse);
}
:host ::ng-deep .stepper-wrapper .p-step:has(~ .p-step-active) .p-step-title {
  color: var(--primary-subtle-inverse);
}
.step-content {
  padding: 16px;
  color: var(--text-default);
  font-size: 14px;
  line-height: 20px;
}
/*# sourceMappingURL=stepper-demo-modal.component.css.map */
